import { LaunchDarklyProvider } from "@mma/common";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { securityCenter } from "../constants/static";
import { AuthorizationContextProvider } from "../context/AuthorizationContextProvider";
import useConfig from "../hooks/useConfig";
import { AuthorizeReturn } from "./AuthorizeReturn";
import Home from "./Home";
import LegalPrivacySummary from "./Legal";

const RoutesWithLDAndAuthProvider = () => {
  const envVariables = useConfig();

  return (
    <LaunchDarklyProvider sdkKey={envVariables.REACT_APP_LAUNCHDARKLY_CLIENT_ID}>
      <AuthorizationContextProvider>
        <Router basename={securityCenter}>
          <Routes>
            <Route path="/legal" element={<LegalPrivacySummary />} />
            <Route path="/consent-management" element={<Home />} />
            <Route path="/trusted-devices" element={<Home />} />
            <Route path="/" element={<AuthorizeReturn />} />
            <Route path="/return" element={<AuthorizeReturn />} />
          </Routes>
        </Router>
      </AuthorizationContextProvider>
    </LaunchDarklyProvider>
  );
};
export default RoutesWithLDAndAuthProvider;
